export enum ResponseStatus {
  Success = 'Success',
  Failure = 'Failure',
}

export enum PasswordFieldType {
  Password = 'password',
  Text = 'text',
}

export enum ThemeMode {
  Light = 'light',
  Dark = 'dark',
}

export enum ToastMessageType {
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
}

export enum DateFilter {
  Today = 'Today',
  ThisMonth = 'This Month',
  LastYear = 'Last Year',
}

export enum DateFilters {
  Today = 'Today',
  ThisYear = 'This year',
  LastThirtyDays = 'Last 30 days',
  LastSixtyDays = 'Last 60 days',
  LastNinetyDays = 'Last 90 days',
  LastYear = 'Last year',
  ThisMonth = 'This Month',
  Custom = 'Custom',
}

export enum ActionType {
  Create = 'Create',
  Update = 'Update',
  Edit = 'Edit',
  Add = 'Add',
}

export enum HoardingStatusFilter {
  Unassigned = 'Unassigned',
  Immediate = 'Immediate Available',
  LongTermBooked = 'Long Term Booked',
  Extendable = 'Extendable',
  AvailableOnHold = 'Available On Hold',
}

export enum DateNameOrder {
  Jan = 'Jan',
  Dec = 'Dec',
  A = 'A',
  Z = 'Z',
}

export enum PollChartType {
  Bar = 'Bar',
  Pie = 'Pie',
  Column = 'Column',
}

export enum ParticipantTableType {
  Selected = 'Selected',
  Available = 'Available',
  Normal = 'Normal',
}

export enum TableSize {
  medium = 'medium',
  small = 'small',
}
